import { Styles } from 'assets/types';

const formFeesItemStyle: Styles = () => ({});

export default formFeesItemStyle;
